import styled from 'styled-components';
import { Box, radius, spacing } from '@landr/maestro';

export const CardWrapper = styled(Box)`
    user-select: none;
    width: 100%;
`;

export const CardTop = styled(Box)<{ backgroundColor: string }>`
    position: relative;
    padding-bottom: 100%;
    border-radius: ${radius('base')};
    overflow: hidden;
    ${({ backgroundColor }) => `background-color: ${backgroundColor};`}
`;

export const CardBottom = styled(Box)`
    padding-top: ${spacing('sm')};
    padding-bottom: ${spacing('sm')};

    ${({ theme }): string => theme.breakpoint('md')`
        padding-top: ${spacing('xs')};
        padding-bottom: ${spacing('xs')};
    `}
`;
